import { Agent, AgentByIDResponse, AgentByUserAuthenticated, AgentCreate, AgentResponse, BillingData, BillingDataPayload, CreateAgentRequest, CreateAgentResponse, CreateDesciptionBody, DescripntionsByTab, GetAgentByUserAuthenticated, GetAgentByUserResponseRequets, GetAgentsResponse, paramsSerchDescription, ResponseVo, UpdateDescriptionsReq, UpdateAgentRequest, UpdateAgentResponse, GetAuthorUserAuthenticated, FindAuthorsResponse, GetAPIDefinitionResponse, CreateAPIDefinitionReq, UpdateAPIDefinitionReq, AgentRelatedResponse, AgentRelatedFilterReq, SaveAgentRelatedReq, UpdateAgentRelatedReq, AgentsPurchasedResponse, AgentsPurchasedReq, ClientUserFindResponse, CreateClientUserReq, UpdateClientUserReq, GetAgentStatsResponse, GetAgentStatsReq, GetAgentStatsFilteredReq } from "@/core/domain/Agent.interfaces";
import { FindAuthorsPaginatedQuery } from "../../../domain/Agent.interfaces";
import { AxiosInstance } from "axios";


export class KaimanService {
  private api: AxiosInstance;
  constructor(api: AxiosInstance) {
    this.api = api;
  }

  async updateUserTermsAcceptance(body: { termsAccepted: boolean; termsAcceptedDate: string; termsVersion: string; }): Promise<void> {
    try {
      const resp = await this.api.post<ResponseVo<null>>(`/api/v1/user/terms/acceptance`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
    } catch (error: any) {
      console.error('Error al actualizar aceptación de términos', error);
      throw error;
    }
  }

  async getBillingDataForCurrentUser(): Promise<BillingData[]> {
    try {
      const resp = await this.api.get<ResponseVo<BillingData[]>>(`/api/v1/billing-data/user`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || "Internal Server Error");
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data ;
    } catch (error: any) {
      console.error("Error al obtener los datos de facturación del usuario", error);
      throw error;
    }
  }

  async getBillingDataById(billingDataId: string): Promise<BillingData | null> {
    try {
      const resp = await this.api.get<ResponseVo<BillingData | null>>(`/api/v1/billing-data/${billingDataId}`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || "Internal Server Error");
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data ?? null;
    } catch (error: any) {
      console.error(`Error al obtener los datos de facturación ${billingDataId}`, error);
      throw error;
    }
  }

  async createBillingData(payload: BillingDataPayload): Promise<BillingData> {
    try {
      const resp = await this.api.post<ResponseVo<BillingData>>(`/api/v1/billing-data`, payload);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || "Internal Server Error");
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data as BillingData;
    } catch (error: any) {
      console.error("Error al crear los datos de facturación", error);
      throw error;
    }
  }

  async updateBillingData(billingDataId: string, payload: BillingDataPayload): Promise<BillingData> {
    try {
      payload.billingDataId = billingDataId;
      const resp = await this.api.put<ResponseVo<BillingData>>(`/api/v1/billing-data`, payload);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || "Internal Server Error");
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data as BillingData;
    } catch (error: any) {
      console.error(`Error al actualizar los datos de facturación ${billingDataId}`, error);
      throw error;
    }
  }


  async getAgents(): Promise<AgentResponse[]> {
    try {
      const resp = await this.api.get<GetAgentsResponse>(`/api/v1/agent`);
      return resp?.data?.data;
    } catch (error: any) {
      console.error('Error al obtener los agentes', error);
      throw error;
    }
  }

  async getAgentsPaged(limit = 3, offset = 0): Promise<AgentResponse[]> {
    try {
      const resp = await this.api.get<GetAgentsResponse>(
        `/api/v1/agent/paged?limit=${limit}&offset=${offset}`
      );
      return resp.data.data;
    } catch (error) {
      console.error("Error al obtener los agentes paginados", error);
      throw error;
    }
  }

  async getAgentsTotal(): Promise<number> {
    try {
      const resp = await this.api.get<{ data: number }>(
        `/api/v1/agent/total`
      );
      return resp.data.data;
    } catch (error) {
      console.error("Error al obtener el total de agentes", error);
      throw error;
    }
  }

  async searchAgentsPaginated(query: string, limit = 6, offset = 0): Promise<AgentResponse[]> {
    try {
      const resp = await this.api.get<GetAgentsResponse>(
        `/api/v1/agent/search/pagination?query=${query}&limit=${limit}&offset=${offset}`
      );
      return resp.data?.data ?? [];
    } catch (error) {
      console.error("Error al buscar agentes", error);
      return [];
    }
  }


  async getAgentById(agentId: string): Promise<Agent> {
    try {
      const resp = await this.api.get<AgentByIDResponse>(`/api/v1/agent/${agentId}`);
      return resp?.data?.data;
    } catch (error: any) {
      console.error('Error al obtener el agente por ID', error);
      throw error;
    }
  }

  async createNewAgent(agent: CreateAgentRequest, file: File): Promise<AgentCreate> {

    try {
      const formData = new FormData();
      formData.append('agentVO', new Blob([JSON.stringify(agent)], { type: 'application/json' }));
      formData.append('files', file);

      const resp = await this.api.post<CreateAgentResponse>(
        `/api/v1/agent`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }

      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al crear el agente', error);
      throw error;
    }
  }
  async getAllAgentsByUserAuthenticated(body: GetAgentByUserResponseRequets): Promise<AgentByUserAuthenticated[]> {
    try {
      const resp = await this.api.post<GetAgentByUserAuthenticated>(`/api/v1/agent/search/filter`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }

      return resp.data?.data || [];
    } catch (error: any) {
      console.error('Error al obtener los agentes del usuario autenticado', error);
      throw error;
    }
  }

  async updateAgent(agent: UpdateAgentRequest, file?: File): Promise<AgentCreate> {
    try {
      const formData = new FormData();
      formData.append('agentVo', new Blob([JSON.stringify(agent)], { type: 'application/json' }));

      if (file) {
        formData.append('files', file);
      } else {
        formData.append('files', new Blob([''], { type: 'application/octet-stream' }));
      }

      const resp = await this.api.put<UpdateAgentResponse>(
        `/api/v1/agent`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }

      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al actualizar el agente', error);
      throw error;
    }
  }

  async getAuthorsByUserAuthenticated(): Promise<GetAuthorUserAuthenticated> {
    try {
      const resp = await this.api.get<ResponseVo<GetAuthorUserAuthenticated>>(`/api/v1/author`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || {} as GetAuthorUserAuthenticated;
    } catch (error: any) {
      console.error('Error al obtener el autor del usuario autenticado', error);
      throw error;
    }
  }



  //Description Service


  async getDescriptionsByAgentAndDescType(params: paramsSerchDescription): Promise<DescripntionsByTab[]> {
    try {
      const resp = await this.api.get<ResponseVo<DescripntionsByTab[]>>(`/api/v1/description`, {
        params: {
          agentId: params.agentId,
          descriptionTypeId: params.descriptionTypeId,
        },
      });
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || [];
    } catch (error: any) {
      console.error('Error al obtener las descripciones del agente', error);
      throw error;
    }
  }



  async createDescriptionByAgent(body: CreateDesciptionBody, file: File): Promise<any> {

    try {
      const formData = new FormData();
      formData.append('descriptionVo', new Blob([JSON.stringify(body)], { type: 'application/json' }));
      formData.append('files', file);

      const resp = await this.api.post<any>(
        `/api/v1/description`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }

      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al crear la descripcion', error);
      throw error;
    }
  }


  async updateDescritionsByTab(body: UpdateDescriptionsReq, file: File): Promise<any> {
    try {
      const formData = new FormData();
      formData.append('descriptionVo', new Blob([JSON.stringify(body)], { type: 'application/json' }));
      formData.append('files', file);

      const resp = await this.api.put<any>(
        `/api/v1/description`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al actualizar la descripcion', error);
      throw error;
    }
  }


  async deleteDescriptionById(descriptionId: string): Promise<any> {
    try {
      const resp = await this.api.delete<any>(`/api/v1/description/${descriptionId}`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al eliminar la descripcion', error);
      throw error;
    }
  }




  //purchase agents


  async getPurchaseState(agentId: string): Promise<string> {
    try {
      const resp = await this.api.get<ResponseVo<string>>(`/api/v1/purchase/${agentId}`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al obtener el estado de compra del agente', error);
      throw error;
    }
  }

  async purchaseAgent(agentId: string, throttlingPolicy?: string): Promise<string> {
    try {
      const url = throttlingPolicy
        ? `/api/v1/purchase?throttlingPolicy=${encodeURIComponent(throttlingPolicy)}`
        : `/api/v1/purchase`;

      const resp = await this.api.post<ResponseVo<string>>(url, {
        agentId,
      });
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al comprar el agente', error);
      throw error;
    }
  }

  async purchaseWithPlan(payload: {
    agentId: string;
    customerId?: string;
    paymentMethodId: string;
    currency?: string;
    selectedPlan: string;
    metadata?: any;
    value?: number;
    features?: string[];
  }): Promise<{subscriptionId: string, status: string, planId: string}> {
    try {
      const requestBody = {
        ...payload,
        currency: payload.currency || 'USD'
      };

      const resp = await this.api.post<ResponseVo<{subscriptionId: string, status: string, planId: string}>>(
        `/api/v1/purchase/with-plan`,
        requestBody
      );

      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }

      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al comprar con plan', error);
      throw error;
    }
  }
  /**
   * 
   * @param payment Data of the payment before the purchase in button pagopulx
   */
  async savePurchasePayment(payment: any): Promise<void> {
    try {
      const resp = await this.api.post<ResponseVo<void>>(`/api/v1/payments/save-payment`, payment);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
    } catch (error: any) {
      console.error('Error al guardar la metadata de la compra', error);
      throw error;
    }
  }

  

  //authors services

  async findAuthorsPaginated(body: FindAuthorsPaginatedQuery): Promise<FindAuthorsResponse[]> {
    try {
      const resp = await this.api.post<ResponseVo<FindAuthorsResponse[]>>(`/api/v1/author/filter`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || [];
    } catch (error) {
      console.error('Error al buscar autores paginados', error);
      throw error;
    }
  }


  async getUserAuthenticatedRole(): Promise<string> {
    try {
      const resp = await this.api.get<ResponseVo<string>>(`/api/v1/auth?role=admin`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al obtener el rol del usuario autenticado', error);
      throw error;
    }
  }


  //api definitions

  async getApiDefinition(agentId: string): Promise<GetAPIDefinitionResponse> {
    try {
      const resp = await this.api.get<ResponseVo<GetAPIDefinitionResponse>>(`/api/v1/apiDefinition/${agentId}`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data ?? {};
    } catch (error: any) {
      console.error('Error al obtener la definición de la API del agente', error);
      throw error;
    }
  }


  async createApiDefinition(body: CreateAPIDefinitionReq, file: File): Promise<any> {

    try {
      const formData = new FormData();
      formData.append('apiDefinitionVo', new Blob([JSON.stringify(body)], { type: 'application/json' }));
      formData.append('file', file);

      const resp = await this.api.post<any>(
        `/api/v1/apiDefinition`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }

      return resp.data?.data ?? resp.data;
    } catch (error: any) {
      console.error('Error al crear la descripcion', error);
      throw error;
    }
  }


  async updateApiDefinition(body: UpdateAPIDefinitionReq, file?: File): Promise<any> {
    try {
      const formData = new FormData();
      formData.append('apiDefinitionVo', new Blob([JSON.stringify(body)], { type: 'application/json' }));
      if (file) {
        formData.append('file', file);
      } else {
        formData.append('file', new Blob([''], { type: 'application/octet-stream' }));
      }

      const resp = await this.api.put<any>(
        `/api/v1/apiDefinition`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data ?? resp.data;
    } catch (error: any) {
      console.error('Error al actualizar la descripcion', error);
      throw error;
    }
  }



  //agent related services

  async getAgentsRelatedByAgent(agentId: string): Promise<any> {
    try {
      const resp = await this.api.get<ResponseVo<AgentRelatedResponse[]>>(`/api/v1/agent-related/${agentId}`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data;
    } catch (error: any) {
      console.error('Error al obtener los agentes relacionados', error);
      throw error;
    }
  }

  async getAgentsFilter(body: AgentRelatedFilterReq): Promise<any> {
    try {
      const resp = await this.api.post<ResponseVo<any>>(`/api/v1/agent-related/filter`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al filtrar agentes relacionados', error);
      throw error;
    }
  }


  async createAgentRelated(body: SaveAgentRelatedReq): Promise<any> {
    try {
      const resp = await this.api.post<ResponseVo<any>>(`/api/v1/agent-related`, body );
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al crear la relación entre agentes', error);
      throw error;
    }
  }

  async updateAgentRelated(body: UpdateAgentRelatedReq): Promise<any> {
    try {
      const resp = await this.api.put<ResponseVo<any>>(`/api/v1/agent-related`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al actualizar la relación entre agentes', error);
      throw error;
    }
  }
  async deleteAgentRelated(agentRelationId: string): Promise<any> {
    try {
      const resp = await this.api.delete<ResponseVo<any>>(`/api/v1/agent-related/${agentRelationId}`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al eliminar la relación entre agentes', error);
      throw error;
    }
  }
  
//agents purchased by client
  async getAgentsPurchased(body: AgentsPurchasedReq): Promise<AgentsPurchasedResponse[]> {
    try {
      const resp = await this.api.post<ResponseVo<AgentsPurchasedResponse[]>>(`/api/v1/client/find`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }

      return resp.data?.data || [];
    } catch (error: any) {
      console.error('Error al obtener agentes adquiridos', error);
      throw error;
    }
  }

  async clientUserFind(body: AgentsPurchasedReq): Promise<ClientUserFindResponse[]> {
    try {
      const resp = await this.api.post<ResponseVo<ClientUserFindResponse[]>>(`/api/v1/client-user/find`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }

      return resp.data?.data || [];
    } catch (error: any) {
      console.error('Error al obtener usuarios cliente', error);
      throw error;
    }
  }


  async createClientUser(body: CreateClientUserReq): Promise<any> {
    try {
      const resp = await this.api.post<ResponseVo<any>>(`/api/v1/client-user`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al crear usuario cliente', error);
      throw error;
    }
  }
async updateClientUser(body: UpdateClientUserReq): Promise<any> { 
    try {
      const resp = await this.api.put<ResponseVo<any>>(`/api/v1/client-user`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al actualizar usuario cliente', error);
      throw error;
    }
  }
   
  async deleteClientUser(clientAgentUserId: string): Promise<any> {
    try {
      const resp = await this.api.delete<ResponseVo<any>>(`/api/v1/client-user/${clientAgentUserId}`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al eliminar usuario cliente', error);
      throw error;
    }
  }

  //stats services
  async getClientUserUsages(queryParams: GetAgentStatsReq): Promise<GetAgentStatsResponse[]> {
    try {
      const resp = await this.api.get<ResponseVo<GetAgentStatsResponse[]>>(`/api/v1/client-user/usages`, {
        params: queryParams,
      });
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al obtener el uso del usuario cliente', error);
      throw error;
    }
  }


  async getClientUserUsagesFiltered(body: GetAgentStatsFilteredReq): Promise<GetAgentStatsResponse[]> {
    try {
      const resp = await this.api.post<ResponseVo<GetAgentStatsResponse[]>>(`/api/v1/client-user/usages`, body);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || resp?.data;
    } catch (error: any) {
      console.error('Error al obtener el uso del usuario cliente filtrado', error);
      throw error;
    }
  }


  //purchase plans
  async getPurchasePlans(agentId: string): Promise<any[]> {
    try {
      const resp = await this.api.get<ResponseVo<any[]>>(`/api/v1/purchase/plans/${agentId}`);
      
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || [];
    } catch (error: any) {
      console.error('Error al obtener planes de compra', error);
      throw error;
    }
  }

  //Stripe payments

  async createCheckoutSession(payload: {
    agentId: string;
    selectedPlan: string;
    unitAmountCents: number;
    productName: string;
    successUrl: string;
    cancelUrl: string;
  }): Promise<{ url: string; successUrl: string; cancelUrl: string }> {
    try {
      const resp = await this.api.post<ResponseVo<{ url: string; successUrl: string; cancelUrl: string }>>(`/api/v1/payments/checkout/session`, {
        agentId: payload.agentId,
        selectedPlan: payload.selectedPlan,
        unitAmountCents: payload.unitAmountCents,
        currency: "USD",
        productName: payload.productName,
        successUrl: payload.successUrl,
        cancelUrl: payload.cancelUrl
      });
      
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Internal Server Error');
        (error as any).code = resp.data?.code;
        throw error;
      }
      
      return resp.data?.data;
    } catch (error: any) {
      console.error('Error creating checkout session', error);
      throw error;
    }
  }

  // Subscription management methods

  async cancelSubscription(clientAgentId: string, payload?: Record<string, unknown>): Promise<any> {
    try {
      const url = `/api/v1/purchase/cancel-subscription/${clientAgentId}`;

      const resp = await this.api.delete<ResponseVo<any>>(url, { data: payload });
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Error cancelling subscription');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data;
    } catch (error: any) {
      console.error('Error cancelling subscription', error);
      throw error;
    }
  }

  async getSubscriptionStatus(clientAgentUserId: string): Promise<string> {
    try {
      const resp = await this.api.get<ResponseVo<string>>(`/api/v1/client-user/${clientAgentUserId}/subscription-status`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Error getting subscription status');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || 'UNKNOWN';
    } catch (error: any) {
      console.error('Error getting subscription status', error);
      throw error;
    }
  }

  // Invoice management methods

  async getUserInvoices(agentId?: string): Promise<any[]> {
    try {
      const url = agentId && agentId.trim().length > 0
        ? `/api/v1/payments/user-invoices?agentId=${agentId}`
        : `/api/v1/payments/user-invoices`;
      const resp = await this.api.get<ResponseVo<any[]>>(url);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Error getting invoices');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || [];
    } catch (error: any) {
      console.error('Error getting user invoices', error);
      throw error;
    }
  }

  async getInvoiceDetails(paymentId: string): Promise<any> {
    try {
      const resp = await this.api.get<ResponseVo<any>>(`/api/v1/payments/invoice/${paymentId}`);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Error getting invoice details');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data || {};
    } catch (error: any) {
      console.error('Error getting invoice details', error);
      throw error;
    }
  }

  async reactivateSubscription(clientAgentId: string): Promise<any> {
    try {
      const url = `/api/v1/billing/subscription/${clientAgentId}/reactivate`;
      
      const resp = await this.api.post<ResponseVo<any>>(url);
      if (resp.data?.code >= 400) {
        const error = new Error((resp.data as any)?.message || 'Error reactivating subscription');
        (error as any).code = resp.data?.code;
        throw error;
      }
      return resp.data?.data;
    } catch (error: any) {
      console.error('[KaimanService] Error reactivating subscription:', error);
      throw error?.response?.data || error;
    }
  }

  
}
